import { render, staticRenderFns } from "./Pressreleases.vue?vue&type=template&id=2b57a044&"
import script from "./Pressreleases.vue?vue&type=script&lang=js&"
export * from "./Pressreleases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports